import { type WebSource } from "../context";

export const getAccountUrl = (webSource: WebSource | undefined) => {
    return webSource === "GROUPS"
        ? `${process.env.NEXT_PUBLIC_WEB_DOMAIN}/myaccount`
        : "/myaccount";
};
